<template>
    <div>
        <LabelContent title="基本信息" ref="LabelContent">
            <div slot="btns">
                <!--<el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <!--<el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                <!--<el-button size="small" type="warning"> 批量移除</el-button>-->
            </div>
        </LabelContent>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="110px"
                     class="unitWidth" size="small">
                <el-form-item label="设备编号">
                    <el-input v-model.trim="searchParams.devCode" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="设备名">
                    <el-input v-model.trim="searchParams.devName" placeholder="请输入设备名(必填)"></el-input>
                </el-form-item>
                <el-form-item label="设备状态">
                    <el-select v-model="searchParams.devStatus" placeholder="请选择设备状态">
                        <el-option label="使用中" value="101"></el-option>
                        <el-option label="闲置中" value="102"></el-option>
                        <el-option label="报废中" value="103"></el-option>
                        <el-option label="移管中" value="104"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否关键设备">
                    <el-switch v-model="searchParams.keyDevices" active-text="是" inactive-text="否"></el-switch>
                </el-form-item>
                <el-form-item label="责任人工号">
                    <el-input v-model.trim="searchParams.personNo" placeholder="请输入责任人工号"></el-input>
                </el-form-item>
                <el-form-item label="责任人">
                    <el-input v-model.trim="searchParams.person" placeholder="请输入责任人"></el-input>
                </el-form-item>
                <el-form-item label="出厂年份">
                    <el-date-picker v-model="searchParams.yearOfManu" type="date" placeholder="选择出厂年份"></el-date-picker>
                </el-form-item>
                <el-form-item label="进厂日期">
                    <el-date-picker v-model="searchParams.dateOfArri" type="date" placeholder="选择进厂日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="使用年限">
                    <el-input v-model.trim="searchParams.serviceLife" placeholder="请输入使用年限"></el-input>
                </el-form-item>
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择所属工厂" :disabled="true">
                        <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                                   :value="factory.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择所属车间" filterable @change="shopChange">
                        <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                                   :value="shop.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择所属工段" filterable @change="sectionChange">
                        <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                                   :value="section.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择所属产线" filterable>
                        <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                                   :value="line.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备位置">
                    <el-input v-model.trim="searchParams.note" placeholder="请输入设备位置"></el-input>
                </el-form-item>
                <el-form-item label="供应商">
                    <el-input v-model.trim="searchParams.devSupplier" placeholder="请输入供应商"></el-input>
                </el-form-item>
                <el-form-item label="供应商联系方式">
                    <el-input v-model.trim="searchParams.devSupConInf" placeholder="请输入供应商联系方式"></el-input>
                </el-form-item>
                <el-form-item label="供应商地址">
                    <el-input v-model.trim="searchParams.devSupplierAddress" placeholder="请输入供应商地址"></el-input>
                </el-form-item>
                <el-form-item label="固定资产编码">
                    <el-input v-model.trim="searchParams.assetsNo" placeholder="请输入固定资产编码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editDevice">确定</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <el-tabs style="margin-left: 1vw" v-model="activeName">
            <!--文件信息-->
            <el-tab-pane label="文件信息" name="first">
                <SearchBox ref="SearchBox">
                    <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                             class="unitWidth" size="small">
                        <el-form-item label="文件名">
                            <el-input v-model.trim="fileTypeName"></el-input>
                        </el-form-item>
                        <el-form-item label="文件名">
                            <el-select v-model="fileType" placeholder="请选择文件类型" clearable @change="getDeviceFile()">
                                <!--<el-option label="维护手册" value="main_man"></el-option>
                                <el-option label="检修规程" value="main_pro"></el-option>
                                <el-option label="作业文件" value="oper_doc"></el-option>
                                <el-option label="电气图" value="elec_dia"></el-option>
                                <el-option label="机加工图" value="mac_dra"></el-option>
                                <el-option label="设备参数" value="equ_par"></el-option>
                                <el-option label="防错清单" value="pro_list"></el-option>
                                <el-option label="其他" value="other"></el-option>-->
                                <el-option v-for="file in fileTypeList" :key="file.etId" :label="file.etName"
                                           :value="file.etCode"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getDeviceFile()">查询</el-button>
                        </el-form-item>
                    </el-form>
                </SearchBox>
                <LabelContent title="文件信息" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                        <el-button size="small" type="success" @click=";(devAdd = true), updateDeviceFile()">新增
                        </el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="deviceFileList" class="center">
                        <el-table-column prop="fileName" sortable label="文件名" show-overflow-tooltip/>
                        <el-table-column prop="fileUrl" sortable label="文件路径" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <a style="color: #63a35c" :href="scope.row.fileUrl">{{ scope.row.fileUrl }}</a>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop="fileType" sortable label="文件类型" show-overflow-tooltip>
                            <template slot-scope="scope">
                                &lt;!&ndash;<span v-if="scope.row.fileType == 'main_man'">维护手册</span>
                                <span v-if="scope.row.fileType == 'main_pro'">检修规程</span>
                                <span v-if="scope.row.fileType == 'oper_doc'">作业文件</span>
                                <span v-if="scope.row.fileType == 'elec_dia'">电气图</span>
                                <span v-if="scope.row.fileType == 'mac_dra'">机加工图</span>
                                <span v-if="scope.row.fileType == 'equ_par'">设备参数</span>
                                <span v-if="scope.row.fileType == 'pro_list'">防错清单</span>
                                <span v-if="scope.row.fileType == 'other'">其他</span>&ndash;&gt;
                                <span v-for="file in fileTypeList" v-if="file.flCode == scope.row.fileType">{{file.flName}}</span>
                            </template>
                        </el-table-column>-->
                        <el-table-column prop="fileTypeName" sortable label="文件类型" show-overflow-tooltip/>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <i class="editBtn iconfont u-youjianbianji"
                                   @click=";(devAdd = false), updateDeviceFile(scope.row)"/>
                                <i class="delBtn iconfont u-shanchu" @click="deleteDeviceFile(scope.row)"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <!--计划保养-->
            <el-tab-pane label="计划保养" name="second">
                <LabelContent title="计划保养" ref="LabelContent">
                    <div slot="btns">
                        <el-button v-show="searchParams.fcCode == 'NJSS'" size="small" type="success" @click=";(planSelect = true),updateConfig()"> 配置推送用户</el-button>
                        <el-button v-show="searchParams.fcCode == 'NJSS'" size="small" type="success" @click=";(planSelect = false),updateConfig()"> 配置验收用户</el-button>
                        <el-button size="small" type="success" @click=";(planAdd = true), updatePlanMantain()"> 新增</el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable"
                     :data="planMantainList"
                     class="center"
                     tooltip-effect="dark"
                     @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="pmiPart" sortable label="保养项目" show-overflow-tooltip/>
                        <el-table-column prop="pmiItem" sortable label="保养项目描述" show-overflow-tooltip/>
                        <el-table-column prop="mainType" sortable label="保养类型" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.mainType == 'mechanics'">机械</span>
                                <span v-if="scope.row.mainType == 'electrical'">电气</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pmiRespType" sortable label="保养方法" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ getPmiRespTypeDesc(scope.row.pmiRespType) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="firstMaintainTime" sortable label="首次保养日期" show-overflow-tooltip/>
                        <el-table-column prop="nextMaintainTime" sortable label="下次保养日期" show-overflow-tooltip/>
                        <el-table-column prop="maintainCycle" sortable label="保养周期" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.maintainCycle == 'week'">每周</span>
                                <span v-if="scope.row.maintainCycle == 'biweekly'">双周</span>
                                <span v-if="scope.row.maintainCycle == 'monthly'">每月</span>
                                <span v-if="scope.row.maintainCycle == 'bimonthly'">两个月</span>
                                <span v-if="scope.row.maintainCycle == 'quarter'">每季</span>
                                <span v-if="scope.row.maintainCycle == 'half_a_year'">半年</span>
                                <span v-if="scope.row.maintainCycle == 'annually'">每年</span>
								<span v-if="scope.row.maintainCycle == 'year_half'">一年半</span>
								<span v-if="scope.row.maintainCycle == 'twoYear'">两年</span>
								<span v-if="scope.row.maintainCycle == 'two_year_half'">两年半</span>
								<span v-if="scope.row.maintainCycle == 'three_year'">三年</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-show="searchParams.fcCode == 'NJSS'" prop="pushUser" sortable label="推送用户" show-overflow-tooltip/>
                        <el-table-column v-show="searchParams.fcCode == 'NJSS'" prop="checkUser" sortable label="验收用户" show-overflow-tooltip/>
                        <el-table-column prop="remark" sortable label="备注" show-overflow-tooltip/>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <i class="editBtn iconfont u-youjianbianji"
                                   @click=";(planAdd = false), updatePlanMantain(scope.row)"/>
                                <i class="delBtn iconfont u-shanchu" @click="deletePlanMantain(scope.row)"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <!--点检项-->
            <el-tab-pane label="点检项" name="third">
                <LabelContent title="点检项" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                        <el-button size="small" type="success" @click=";(dailyAdd = true), updateDailyCheckd()"> 新增
                        </el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="dailyCheckdList" class="center">
                        <el-table-column prop="dciNum" sortable label="点检序号" show-overflow-tooltip/>
                        <el-table-column prop="ckType" sortable label="点检项" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.ckType.desc }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="checkValType" sortable label="检测类型" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.checkValType.desc }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dciPart" sortable label="点检部位" show-overflow-tooltip/>
                        <el-table-column prop="dciDesc" sortable label="点检要求" show-overflow-tooltip/>
                        <el-table-column prop="productCode" sortable label="产品号" show-overflow-tooltip/>
                        <el-table-column prop="remark" sortable label="备注" show-overflow-tooltip/>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <i class="editBtn iconfont u-youjianbianji"
                                   @click=";(dailyAdd = false), updateDailyCheckd(scope.row)"/>
                                <i class="delBtn iconfont u-shanchu" @click="deleteDailyCheckd(scope.row)"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <!--能力检测项-->
            <el-tab-pane label="能力检测" name="ability">
                <LabelContent title="能力检测项" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                        <el-button size="small" type="success" @click=";(detecthItemIfAdd = true),packDetectnItem()">
                            新增
                        </el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="detecthItems" class="center">
                        <el-table-column prop="adiItem" sortable label="保养项目" show-overflow-tooltip/>
                        <el-table-column prop="adiJudgment" sortable label="判定标准" show-overflow-tooltip/>
                        <el-table-column prop="adiMethod" sortable label="检测方法" show-overflow-tooltip/>
                        <el-table-column prop="adiType" sortable label="项目类型" show-overflow-tooltip/>
                        <el-table-column prop="groupAmount" sortable label="每组数量" show-overflow-tooltip/>
                        <el-table-column prop="groupTotal" sortable label="总组数" show-overflow-tooltip/>
                        <el-table-column prop="numTests" sortable label="测试次数" show-overflow-tooltip/>
                        <el-table-column prop="createUser" sortable label="创建用户" show-overflow-tooltip/>
                        <el-table-column prop="createTime" sortable label="创建时间" show-overflow-tooltip/>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <i class="editBtn iconfont u-youjianbianji"
                                   @click=";(detecthItemIfAdd = true),packDetectnItem(scope.row)"/>
                                <i class="delBtn iconfont u-shanchu" @click="deleteDetectnItem(scope.row.adiId)"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <!--历史经验-->
            <el-tab-pane label="历史经验" name="four">
                <LabelContent title="历史经验" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                        <el-button size="small" type="success" @click=";(repairAdd = true), updateRepair()"> 新增
                        </el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="repairExpList" class="center">
                        <el-table-column prop="faultCode" label="关联故障代码"/>
                        <el-table-column prop="repairPhenomenon" label="故障现象"/>
                        <el-table-column prop="repairReason" label="故障原因分析"/>
                        <el-table-column prop="repairResolvent" label="故障解决方法"/>
                        <el-table-column prop="repairOccurrenceTime" label="故障发生时间" width="180"/>
                        <el-table-column prop="updFile" label="相关附件" width="420">
                            <template slot-scope="scope">
                                <a v-for="file in scope.row.updFile" style="color: #63a35c" :href="file">{{ file }}<br/></a>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <i class="editBtn iconfont u-youjianbianji"
                                   @click=";(repairAdd = false), updateRepair(scope.row)"/>
                                <i class="delBtn iconfont u-shanchu" @click="delRepair(scope.row)"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <!-- 设备运行状态 -->
            <el-tab-pane label="设备状态变化" name="five">
                <LabelContent title="设备状态变化" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                        <!-- <el-button size="small" type="success" @click=";(repairAdd = true), updateRepair()"> 新增
                        </el-button> -->
                        <el-button size="small" type="success" @click="exportDeviceRunStatusChange">导出</el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="deviceChangeList" class="center">
                        <el-table-column prop="devRunStatus.desc" label="设备运行状态"/>
                        <!--<el-table-column prop="changeType.desc" label="状态改变类型"/>
                        <el-table-column prop="objId" label="改变对象"/>-->
                        <el-table-column prop="objUserId" label="改变用户"/>
                        <!--<el-table-column prop="lineCode" label="产线"/>-->
                        <el-table-column prop="changeStartTime" label="状态开始时间"/>
                        <el-table-column prop="changeEndTime" label="状态结束时间"/>
                        <!--<el-table-column prop="totalTime" label="总用时(分)"/>-->
                        <el-table-column prop="createTime" label="创建时间"/>
                    </el-table>
                    <el-pagination
                        @size-change="deviceChangePaginationChange"
                        @current-change="deviceChangePaginationCurrentChange"
                        :current-page="deviceChangeData.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="deviceChangeData.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="deviceChangeData.pageCount"
                    />
                </div>
            </el-tab-pane>
            <!--故障代码-->
            <!--<el-tab-pane label="故障代码" name="five">
                <LabelContent title="故障代码" ref="LabelContent">
                    <div slot="btns">
                        &lt;!&ndash;                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>&ndash;&gt;
                        &lt;!&ndash;                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>&ndash;&gt;
                        &lt;!&ndash; <el-button size="small" type="warning"> 批量移除</el-button> &ndash;&gt;
                        <el-button size="small" type="success" @click=";(faultCodeAdd = true),updateFaultCode()"> 新增</el-button>
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="faultCodeList" class="center">
                        <el-table-column prop="faultCode" sortable label="故障编号" show-overflow-tooltip />
                        <el-table-column prop="faultName" sortable label="故障名称" show-overflow-tooltip />
                        <el-table-column prop="faultDes" sortable label="故障描述" show-overflow-tooltip />
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <i class="editBtn iconfont u-youjianbianji" @click=";(faultCodeAdd = false),updateFaultCode(scope.row)" />
                                <i class="delBtn iconfont u-shanchu" @click="delFaultCode(scope.row)" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>-->
            <!--操作日志-->
            <el-tab-pane label="操作日志" name="fourth">
                <LabelContent title="操作日志" ref="LabelContent">
                    <div slot="btns">
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                        <!--                <el-button size="small" type="success" @click=";(ifAdd = true),updatehOpen()"> 新增</el-button>-->
                        <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
                    </div>
                </LabelContent>
                <div class="tableBox">
                    <el-table stripe ref="multipleTable" :data="deviceOperationLogList" class="center">
                        <el-table-column prop="doType" sortable label="操作日志" width="110"/>
                        <el-table-column prop="userName" sortable label="操作人" width="110"/>
                        <el-table-column prop="createTime" sortable label="操作时间" width="160"/>
                        <el-table-column prop="operationType" sortable label="操作类型" width="110"/>
                        <el-table-column prop="doContent" sortable label="操作内容"/>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!--新增点检文件-->
        <el-dialog :title="devAdd ? '新增' : '修改'" width="50vw" :visible.sync="deviceShow" style="text-align: left">
            <el-form :model="deviceFile" :rules="device" ref="device" label-width="100px" class="demo-roleForm">
                <el-form-item label="文件名" prop="fileName">
                    <el-input v-model.trim="deviceFile.fileName" placeholder="请输入文件名"></el-input>
                </el-form-item>
                <el-form-item label="文件">
                    <el-upload
                        v-show="fileUpload"
                        class="upload-demo"
                        :headers="{ 'X-Auth-Token': token }"
                        :action="URL"
                        :on-success="handleSuccess"
                        :on-remove="delImg"
                        :file-list="fileList"
                        :clearFiles="clearFiles"
                        :limit="1"
                    >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <!--                    <el-input v-show="fileUrlShow" v-model="deviceFile.fileUrl" disabled></el-input>-->
                    <span v-show="fileUrlShow">{{ deviceFile.fileUrl }}</span>
                </el-form-item>
                <el-form-item label="文件类型" prop="fileType">
                    <el-select v-model="deviceFile.fileType" placeholder="请选择文件类型">
                        <!--<el-option label="维护手册" value="main_man"></el-option>
                        <el-option label="检修规程" value="main_pro"></el-option>
                        <el-option label="作业文件" value="oper_doc"></el-option>
                        <el-option label="电气图" value="elec_dia"></el-option>
                        <el-option label="机加工图" value="mac_dra"></el-option>
                        <el-option label="设备参数" value="equ_par"></el-option>
                        <el-option label="防错清单" value="pro_list"></el-option>
                        <el-option label="其他" value="other"></el-option>-->
                        <el-option v-for="file in fileTypeList" :key="file.etId" :label="file.etName"
                                   :value="file.etCode"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deviceShow = false">取 消</el-button>
                <el-button type="primary" @click="saveDeviceFile('device')">{{ devAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>

        <!--新增计划保养-->
        <el-dialog :title="planAdd ? '新增' : '修改'" width="50vw" :visible.sync="planManShow" @close="clearUsers()" style="text-align: left">
            <el-form :model="planMantain" :rules="planMan" ref="planMan" label-width="150px" class="demo-roleForm">
                <el-form-item label="保养项目" prop="pmiPart">
                    <el-input v-model.trim="planMantain.pmiPart" placeholder="请输入保养项目"></el-input>
                </el-form-item>
                <el-form-item label="保养项目描述" prop="pmiItem">
                    <el-input type="textarea" :rows="2" v-model.trim="planMantain.pmiItem"
                              placeholder="请输入保养项目描述"></el-input>
                </el-form-item>
                <el-form-item label="保养类型" prop="mainType">
                    <el-select v-model="planMantain.mainType" placeholder="请选择保养类型">
                        <el-option label="机械" value="mechanics"></el-option>
                        <el-option label="电气" value="electrical"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="保养方法" prop="pmiRespType">
                    <el-select v-model="planMantain.pmiRespType" placeholder="请选择保养方法">
                        <el-option v-for="item in pmiRespTypeList" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="首次保养日期" prop="firstMaintainTime">
                    <el-date-picker :picker-options="pickerOptions" v-model="planMantain.firstMaintainTime" type="date"
                                    placeholder="选择首次保养日期" @focus="donnes"></el-date-picker>
                </el-form-item>
                <el-form-item label="保养周期" prop="maintainCycle">
                    <!--                    <el-input-number v-model="planMantain.maintainCycle" :min="0"></el-input-number>-->
                    <el-select v-model="planMantain.maintainCycle" placeholder="请选择保养周期">
                        <el-option label="每周" value="week"></el-option>
                        <el-option label="双周" value="biweekly"></el-option>
                        <el-option label="每月" value="monthly"></el-option>
                        <el-option label="两个月" value="bimonthly"></el-option>
                        <el-option label="每季" value="quarter"></el-option>
                        <el-option label="半年" value="half_a_year"></el-option>
                        <el-option label="每年" value="annually"></el-option>
            			 <el-option label="一年半" value="year_half"></el-option>
            			  <el-option label="两年" value="twoYear"></el-option>
            			   <el-option label="两年半" value="two_year_half"></el-option>
            			    <el-option label="三年" value="three_year"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="searchParams.fcCode == 'NJSS'" label="推送角色">
                    <el-select v-model="planMantain.roleList" multiple collapse-tags placeholder="请选择" @change="getPlanMainByPmiId()">
                        <el-option v-for="role in roleList" :key="role.roleId" :label="role.roleName" :value="role.roleId"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="searchParams.fcCode == 'NJSS'" label="推送用户">
                    <el-select v-model="planMantain.userList" multiple collapse-tags placeholder="请选择" @change="change()">
                        <el-option
                          v-for="user in userList"
                          :key="user.userId"
                          :label="user.userName"
                          :value="user.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="searchParams.fcCode == 'NJSS'" label="验收角色">
                    <el-select v-model="planMantain.checkRoleList" multiple collapse-tags placeholder="请选择" @change="getPlanMainCheckByPmiId()">
                        <el-option v-for="role in roleList" :key="role.roleId" :label="role.roleName" :value="role.roleId"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="searchParams.fcCode == 'NJSS'" label="验收用户">
                    <el-select v-model="planMantain.checkUserList" multiple collapse-tags placeholder="请选择" @change="change()">
                        <el-option
                          v-for="user in checkUserList"
                          :key="user.userId"
                          :label="user.userName"
                          :value="user.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="planMantain.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="planManShow = false">取 消</el-button>
                <el-button type="primary" @click="savePlanMan('planMan')">{{ planAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>

        <!--推送/验收计划保养-->
        <el-dialog :title="planSelect ? '添加推送用户' : '添加验收用户'" width="50vw" :visible.sync="planPushORCheckShow" @close="clearSelect()" style="text-align: left">
            <el-form :model="planSelectList" :rules="planMan" ref="planMan" label-width="150px" class="demo-roleForm">
                <el-form-item v-show="searchParams.fcCode == 'NJSS'" label="角色">
                    <el-select v-model="planSelectList.roleList" multiple collapse-tags placeholder="请选择" @change="getConfigRoleList()">
                        <el-option v-for="role in roleList" :key="role.roleId" :label="role.roleName" :value="role.roleId"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="searchParams.fcCode == 'NJSS'" label="通知用户">
                    <el-select v-model="planSelectList.userList" multiple collapse-tags placeholder="请选择">
                        <el-option
                          v-for="user in selectUserList"
                          :key="user.userId"
                          :label="user.userName"
                          :value="user.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="planPushORCheckShow = false">取 消</el-button>
                <el-button type="primary" @click="addItem()">新增</el-button>
            </span>
        </el-dialog>

        <!--新增点检项-->
        <el-dialog :title="dailyAdd ? '新增' : '修改'" width="500px" :visible.sync="dailyCheckdShow"
                   style="text-align: left">
            <el-form :model="dailyCheckd" :rules="daily" ref="daily" label-width="110px" class="demo-roleForm">
                <el-form-item label="点检序号" prop="dciNum">
                    <el-input-number v-model="dailyCheckd.dciNum" placeholder="请输入点检序号"
                                     :disabled="dailyAdd ? false : true"></el-input-number>
                </el-form-item>
                <el-form-item label="项目类别" prop="ckType">
                    <el-select v-model="dailyCheckd.ckType" placeholder="请选择项目类别">
                        <el-option label="检查项" value="check_item"></el-option>
                        <el-option label="清洁项" value="clean_item"></el-option>
                        <el-option label="润滑项" value="lubricate_item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="检测类型" prop="checkValType">
                    <el-select v-model="dailyCheckd.checkValType" placeholder="请选择检测类型">
                        <el-option label="OK/NG类型" value="is_ok"></el-option>
                        <el-option label="数字类型" value="number_type"></el-option>
                        <el-option label="描述类型" value="des_type"></el-option>
                        <el-option label="图片类型" value="pic_type"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="点检部位" prop="dciPart">
                    <el-input v-model.trim="dailyCheckd.dciPart" placeholder="请输入点检部位"></el-input>
                </el-form-item>
                <el-form-item label="点检要求" prop="dciDesc">
                    <el-input v-model.trim="dailyCheckd.dciDesc" placeholder="请输入点检要求"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model.trim="dailyCheckd.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="产品号">
                    <el-input v-model.trim="dailyCheckd.productCode" placeholder="请输入产品号"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dailyCheckdShow = false">取 消</el-button>
                <el-button type="primary" @click="saveDailyCheckd('daily')">{{ dailyAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>

        <!--新增能力检测项-->
        <el-dialog :title="itemAddTitle" width="500px" :visible.sync="dailyDetectnShow" style="text-align: left">
            <el-form :model="detecthItem" :rules="detecthCheck" ref="detecthCheck" label-width="110px"
                     class="demo-roleForm">
                <el-form-item label="保养项目" prop="adiItem">
                    <el-input v-model="detecthItem.adiItem" placeholder="请输入保养项目" @input="change($event)"></el-input>
                </el-form-item>
                <el-form-item label="检测方法" prop="adiMethod">
                    <el-input v-model="detecthItem.adiMethod" placeholder="请输入检测方法" @input="change($event)"></el-input>
                </el-form-item>
                <el-form-item label="判定标准" prop="adiJudgment">
                    <el-input v-model="detecthItem.adiJudgment" placeholder="请输入判定标准"
                              @input="change($event)"></el-input>
                </el-form-item>

                <el-form-item label="项目类别" prop="adiType">
                    <el-select v-model="detecthItem.adiType" placeholder="请选择项目类别" @change="selectAdiType()">
                        <el-option label="CMK" value="CMK"></el-option>
                        <el-option label="CPK" value="CPK"></el-option>
                        <el-option label="PPK" value="PPK"></el-option>
                        <el-option label="CGK" value="CGK"></el-option>
                        <el-option label="GRR" value="GRR"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="总组数" prop="groupTotal">
                    <el-input-number id="groupTotal" :min="1" :max="maxGroupTotal" v-model="detecthItem.groupTotal"
                                     placeholder="请输入总组数" @input="change($event)"></el-input-number>
                </el-form-item>
                <el-form-item label="分组数量" prop="groupAmount">
                    <el-input-number id="groupAmount" :min="1" :max="10" :disabled="disabledGroup"
                                     v-model="detecthItem.groupAmount" placeholder="分组数量"
                                     @input="change($event)"></el-input-number>
                </el-form-item>
                <el-form-item v-if="disabledGroup == true" label="测试次数" prop="groupAmount">
                    <el-input-number v-model="detecthItem.numTests" :min="2" :max="3" placeholder="测试次数"
                                     @input="change($event)"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click=";(dailyDetectnShow = false), (disabledGroup = false)">取 消</el-button>
                <el-button type="primary" @click="editDetectnItem('detecthCheck')">{{ itemAddTitle }}</el-button>
            </div>
        </el-dialog>

        <!--新增历史经验-->
        <el-dialog :title="repairAdd ? '新增' : '修改'" width="50vw" :visible.sync="repairShow" style="text-align: left">
            <el-form :model="repairExp" :rules="repair" ref="repair" label-width="110px" class="demo-roleForm">
                <el-form-item label="关联故障代码">
                    <el-input v-model.trim="repairExp.faultCode" placeholder="请输入关联故障代码"></el-input>
                </el-form-item>
                <el-form-item label="故障现象" prop="repairPhenomenon">
                    <el-input v-model.trim="repairExp.repairPhenomenon" placeholder="请输入故障现象"></el-input>
                </el-form-item>
                <el-form-item label="故障原因分析" prop="repairReason">
                    <el-input v-model.trim="repairExp.repairReason" placeholder="请输入故障原因分析"></el-input>
                </el-form-item>
                <el-form-item label="故障解决方法" prop="repairResolvent">
                    <el-input v-model.trim="repairExp.repairResolvent" placeholder="请输入故障解决方法"></el-input>
                </el-form-item>
                <el-form-item label="故障发生时间" prop="repairOccurrenceTime">
                    <el-date-picker v-model="repairExp.repairOccurrenceTime" type="datetime"
                                    placeholder="选择故障发生时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="相关附件">
                    <el-upload v-show="repairFileUpload" :headers="{ 'X-Auth-Token': token }" :action="URL"
                               :on-success="handleSuccessRepair" :on-remove="delImg" :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <!--                    <el-input v-show="fileUrlShow" v-model="deviceFile.fileUrl" disabled></el-input>-->
                    <!--                        <span v-show="repairFileUploadShow">{{repairExp.updFile}}</span>-->
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="repairShow = false">取 消</el-button>
                <el-button type="primary" @click="saveRepairExp('repair')">{{ repairAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>

        <!--新增故障代码-->
        <el-dialog :title="faultCodeAdd ? '新增' : '修改'" width="500px" :visible.sync="faultCodeShow"
                   style="text-align: left">
            <el-form :model="faultCodeDfc" :rules="fault" ref="fault" label-width="110px" class="demo-roleForm">
                <el-form-item label="故障编号" prop="faultCode">
                    <el-input v-model.trim="faultCodeDfc.faultCode" placeholder="请输入故障编号"></el-input>
                </el-form-item>
                <el-form-item label="故障名称" prop="faultName">
                    <el-input v-model.trim="faultCodeDfc.faultName" placeholder="请输入故障名称"></el-input>
                </el-form-item>
                <el-form-item label="故障描述" prop="faultDes">
                    <el-input v-model.trim="faultCodeDfc.faultDes" placeholder="请输入故障描述"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="faultCodeShow = false">取 消</el-button>
                <el-button type="primary" @click="saveFaultCode('fault')">{{ faultCodeAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import abilityDetectnItem from '../../../api/detectnItem.js'
    import moment from 'moment'
    import {
        addDailyCheckItem,
        addPlanMantainItem, deleteDailyCheckItem, editDailyCheckItem,
        editDeviceFile, exportDeviceRunStatusChange,
        getDailyCheckItemDevCode, getDeviceRunStatusChange, getFaultCodeDevCode,
        getPlanMantainItemDevCode, getPmiRespTypes, getAllRole, getUserItemByPmiId,addItemCheekByPmiId,addItemByPmiId,
        getUserItemCheckByPmiId
    } from '../../../libs/api'

    export default {
        name: 'editDevice',
        data() {
            return {
                //选中计划保养项
                selectPmiList: [],
                selectRoleList: [],
                selectUserList: [],
                multipleSelection: [],
                maxGroupTotal: 100,
                disabledGroup: false,
                thisPmiId: '',
                fileList: [],
                roleList: [],
                userList: [],
                checkUserList:[],
                fileType: '',
                fileTypeName: '',
                searchParams: {},
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                activeName: 'first',
                URL: '',
                token: '',
                clearFiles: '',
                devAdd: false,
                deviceShow: false,
                deviceFileList: [],
                deviceFile: {
                    fileName: '',
                    devCode: '',
                    fileUrl: '',
                    fileType: ''
                },
                device: {
                    /*fileUrl: [
                        {
                            required: true,
                            message: '请选择文件'
                        }
                    ],*/
                    fileName: [
                        {
                            required: true,
                            message: '请输入文件名',
                            trigger: 'change'
                        }
                    ],
                    fileType: [
                        {
                            required: true,
                            message: '请选择文件类型',
                            trigger: 'change'
                        }
                    ]
                },
                planAdd: false,
                planManShow: false,
                planSelect: false,
                planPushORCheckShow: false,
                planMantainList: [],
                pmiRespTypeList: [],
                pickerOptions: {
                    if(time) {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
                planMantain: {
                    devCode: '',
                    pmiPart: '',
                    pmiItem: '',
                    mainType: '',
                    roleList: [],
                    userList: [],
                    checkRoleList:[],
                    checkUserList:[],
                    pmiRespType: '',
                    firstMaintainTime: '',
                    maintainCycle: '',
                    remark: ''
                },
                planSelectList:{

                },
                planMan: {
                    pmiPart: [
                        {
                            required: true,
                            message: '请填写保养部位',
                            trigger: 'blur'
                        }
                    ],
                    pmiItem: [
                        {
                            required: true,
                            message: '请填写保养项目描述',
                            trigger: 'blur'
                        }
                    ],
                    mainType: [
                        {
                            required: true,
                            message: '请选择保养类型',
                            trigger: 'blur'
                        }
                    ],
                    pmiRespType: [
                        {
                            required: true,
                            message: '请选择保养方法',
                            trigger: 'blur'
                        }
                    ],
                    firstMaintainTime: [
                        {
                            required: true,
                            message: '请选择首次保养时间',
                            trigger: 'blur'
                        }
                    ],
                    maintainCycle: [
                        {
                            required: true,
                            message: '请输入周期',
                            trigger: 'blur'
                        }
                    ],
                    remark: [
                        {
                            required: true,
                            message: '请输入备注',
                            trigger: 'blur'
                        }
                    ]
                },
                today: new Date(),
                dailyAdd: false,
                dailyCheckdShow: false,
                dailyCheckdList: [],
                dailyCheckd: {
                    devCode: '',
                    ckType: '',
                    dciPart: '',
                    dciDesc: '',
                    checkValType: '',
                    dciNum: '',
                    remark: '',
                    productCode: ''
                },
                daily: {
                    ckType: [
                        {
                            required: true,
                            message: '请填写项目类别',
                            trigger: 'blur'
                        }
                    ],
                    dciPart: [
                        {
                            required: true,
                            message: '请填写点检部位',
                            trigger: 'blur'
                        }
                    ],
                    dciDesc: [
                        {
                            required: true,
                            message: '请填写点检要求',
                            trigger: 'blur'
                        }
                    ],
                    checkValType: [
                        {
                            required: true,
                            message: '请填写检测类型',
                            trigger: 'blur'
                        }
                    ],
                    dciNum: [
                        {
                            required: true,
                            message: '请输入点检序号',
                            trigger: 'blur'
                        }
                    ],
                    remark: [
                        {
                            required: true,
                            message: '请输入备注',
                            trigger: 'blur'
                        }
                    ],
                    productCode: [
                        {
                            required: true,
                            message: '请输入产品号',
                            trigger: 'blur'
                        }
                    ]
                },
                repairExpList: [],
                repairAdd: false,
                repairShow: false,
                repairExp: {
                    devCode: '',
                    faultCode: '',
                    repairPhenomenon: '',
                    repairReason: '',
                    repairResolvent: '',
                    repairOccurrenceTime: '',
                    updFile: '',
                    isActive: ''
                },
                repair: {
                    repairPhenomenon: [
                        {
                            required: true,
                            message: '请输入故障现象',
                            trigger: 'blur'
                        }
                    ],
                    repairReason: [
                        {
                            required: true,
                            message: '请输入故障原因分析',
                            trigger: 'blur'
                        }
                    ],
                    repairResolvent: [
                        {
                            required: true,
                            message: '请输入故障解决方法',
                            trigger: 'blur'
                        }
                    ],
                    repairOccurrenceTime: [
                        {
                            required: true,
                            message: '请选择故障发生时间',
                            trigger: 'blur'
                        }
                    ]
                },
                faultCodeList: [],
                faultCodeAdd: false,
                faultCodeShow: false,
                faultCodeDfc: {
                    devCode: '',
                    faultCode: '',
                    faultName: '',
                    faultDes: ''
                },
                fault: {
                    faultCode: [
                        {
                            required: true,
                            message: '请输入故障编号',
                            trigger: 'blur'
                        }
                    ],
                    faultName: [
                        {
                            required: true,
                            message: '请输入故障名称',
                            trigger: 'blur'
                        }
                    ],
                    faultDes: [
                        {
                            required: true,
                            message: '请输入故障描述',
                            trigger: 'blur'
                        }
                    ]
                },
                fileUrlShow: false,
                fileUpload: true,
                deviceOperationLogList: [],
                detecthItem: {
                    adiId: 0,
                    devCode: '',
                    adiItem: '',
                    adiMethod: '',
                    adiJudgment: '',
                    adiType: '',
                    groupTotal: '',
                    groupAmount: '',
                    numTests: ''
                },
                detecthItemIfAdd: false,
                detecthItems: [],
                itemAddTitle: '',
                dailyDetectnShow: false,
                detecthCheck: {
                    adiItem: [
                        {
                            required: true,
                            message: '请填写保养项目',
                            trigger: 'blur'
                        }
                    ],
                    adiMethod: [
                        {
                            required: true,
                            message: '请填写检测方法',
                            trigger: 'blur'
                        }
                    ],
                    adiJudgment: [
                        {
                            required: true,
                            message: '请填写判定标准',
                            trigger: 'blur'
                        }
                    ],
                    adiType: [
                        {
                            required: true,
                            message: '请填写项目类型',
                            trigger: 'blur'
                        }
                    ],
                    groupTotal: [
                        {
                            required: true,
                            message: '请填写总组数',
                            trigger: 'blur'
                        }
                    ],
                    groupAmount: [
                        {
                            required: true,
                            message: '请填写每组数量',
                            trigger: 'blur'
                        }
                    ]
                },
                repairFileUploadShow: false,
                repairFileUpload: true,
                deviceOperationLogList: [],
                fileTypeList: [],
                deviceChangeList: [],
                deviceChangeData: {
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                }
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    for (var i = 0; i < this.factoryTree.length; i++) {
                        arr.push({
                            label: this.factoryTree[i].deptName,
                            id: this.factoryTree[i].deptID,
                            value: JSON.stringify(this.factoryTree[i]),
                            deptLevel: this.factoryTree[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                this.URL = 'https://tpm.joysonsafety.com.cn/api/upload/files'
                // this.URL = 'https://tpm.joysonsafety.com.cn/back/api/upload/files'
                // this.URL = this.$api.uplodFiles
                this.token = sessionStorage.getItem('authToken')
                if (this.$route.params.device != undefined && this.$route.params.device != '') {
                    this.searchParams = this.$route.params.device
                    sessionStorage.setItem('editDeviceParam', JSON.stringify(this.searchParams))
                } else {
                    this.searchParams = JSON.parse(sessionStorage.getItem('editDeviceParam'))
                }
                this.getData()
                this.getFileTypeList()
                this.getDeviceInfoDevCode()
                this.getAllRole()
                this.getPmiRespTypeList()
            },
            getPmiRespTypeList() {
                let options = {
                    method: 'GET',
                    url: this.$api.getPmiRespTypes
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.pmiRespTypeList = response.data || []
                    }
                })
            },
            getPmiRespTypeDesc(code) {
                if (!code) return ''
                let item = this.pmiRespTypeList.find(x => x.code === code)
                return item ? item.desc : code
            },
            change(e) {
                this.$forceUpdate()
            },
            selectAdiType: function() {
                var self = this
                if (self.detecthItem.adiType == 'GRR') {
                    self.maxGroupTotal = 3
                    self.detecthItem.groupTotal = 3
                    self.disabledGroup = true
                    self.detecthItem.groupAmount = 30
                } else {
                    self.maxGroupTotal = 100
                    self.disabledGroup = false
                    self.detecthItem.groupTotal = ''
                    self.detecthItem.groupAmount = ''
                }
            },
            packDetectnItem(data) {
                var self = this
                self.disabledGroup = false
                self.detecthItem = {}
                if (data == undefined || data == null) {
                    self.itemAddTitle = '新增'
                    self.detecthItem.devCode = self.searchParams.devCode
                } else {
                    self.detecthItem.devCode = self.searchParams.devCode
                    self.detecthItem.adiId = data.adiId
                    self.detecthItem.adiItem = data.adiItem
                    self.detecthItem.adiMethod = data.adiMethod
                    self.detecthItem.adiJudgment = data.adiJudgment
                    self.detecthItem.adiType = data.adiType
                    self.detecthItem.groupTotal = data.groupTotal
                    self.detecthItem.groupAmount = data.groupAmount
                    self.itemAddTitle = '修改'
                    if (self.detecthItem.adiType == 'GRR') {
                        self.detecthItem.numTests = data.numTests
                        self.disabledGroup = true
                    }
                }
                self.dailyDetectnShow = true
            },
            detectnItemList() {
                if (this.searchParams.devCode == undefined || this.searchParams.devCode == '') {
                    return
                }
                let queryParams = {
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'get',
                    url: abilityDetectnItem.abilityDetectnItemList,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.detecthItems = response.data
                    }
                })
            },
            editDetectnItem(detecthCheck) {
                this.$refs[detecthCheck].validate((valid) => {
                    if (valid) {
                        let options = {
                            method: 'POST',
                            url: abilityDetectnItem.editAbilityDetectnItem,
                            data: this.detecthItem
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.$message.success(this.detecthItemIfAdd ? '新增成功！！！' : '编辑成功！！！')
                                this.detectnItemList()
                                this.getDeviceOperationLog()
                                this.dailyDetectnShow = false
                            } else {
                                this.$message.error(this.detecthItemIfAdd ? '新增失败！！！' : '编辑失败！！！')
                            }

                        })
                    } else {
                        return false
                    }
                })
            },
            deleteDetectnItem(adiId) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                params: {
                                    adiId: adiId
                                },
                                url: abilityDetectnItem.deleteAbilityDetectnItem
                            })
                            .then(response => {
                                this.detectnItemList()
                                this.getDeviceOperationLog()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.detectnItemList()
                                this.getDeviceOperationLog()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.detectnItemList()
                        this.getDeviceOperationLog()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            donnes() {
                var arrTime = []
                for (let i = 0; i < 3; i++) {
                    var tempDate = new Date() // 获取今天的日期
                    tempDate.setDate(tempDate.getDate() + i) // 今天的前N天的日期，N自定义
                    arrTime.push(moment(tempDate).format('YYYY-MM-DD'))
                }
                this.pickerOptions = {
                    disabledDate(time) {
                        for (let i = 0; i < arrTime.length; i++) {
                            let date = new Date(arrTime[i])
                            const day = new Date(new Date(date.toLocaleDateString()).getTime() + 1000 * 60 * 60 * 24)
                            if (time.getTime() === day.getTime() - 24 * 60 * 60 * 1000) {
                                return true
                            }
                        }
                        if (time) {
                            return time.getTime() < Date.now() - 8.64e7
                        }
                    }
                }
            },
            getDeviceInfoDevCode() {
                let params = {
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getDeviceInfoDevCode,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.searchParams = JSON.parse(JSON.stringify(response.data))
                        }
                    }
                })
            },
            handleSuccess(res, file) {
                this.fileList = []
                this.deviceFile.fileUrl = file.response.data
                if (this.devAdd) {
                    this.fileUrlShow = true
                    this.fileUpload = true
                } else {
                    this.fileUrlShow = true
                    this.fileUpload = true
                }
            },
            handleSuccessRepair(res, file) {
                let str = ''
                this.fileList.push({ name: file.name, url: file.response.data })
                for (let i = 0; i < this.fileList.length; i++) {
                    str += this.fileList[i].url + ','
                }
                str = str.substring(0, str.length - 1)
                this.repairExp.updFile = str
                if (this.repairAdd) {
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                } else {
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                }
            },
            delImg(file, fileList) {
                let str = ''
                this.fileList = fileList
                for (let i = 0; i < this.fileList.length; i++) {
                    str += this.fileList[i].url + ','
                    console.log('this.fileList[i].url', this.fileList[i].url)
                }
                str = str.substring(0, str.length - 1)
                this.repairExp.updFile = str
                console.log('this.fileList', this.fileList)
                console.log('this.repairExp.updFile', this.repairExp.updFile)
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
            },
            sectionChange: function() {
                this.lineSelected = ''
            },
            getDeviceFile() {
                if (this.searchParams.devCode == undefined || this.searchParams.devCode == '') {
                    return
                }
                let queryParams = {
                    devCode: this.searchParams.devCode,
                    fileTypeName: this.fileTypeName,
                    fileType: this.fileType
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getDeviceFileDevCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.deviceFileList = response.data
                    }
                })
            },
            updateDeviceFile(row) {
                this.fileList = []
                if (this.devAdd) {
                    this.deviceFile = {}
                    this.deviceFile.devCode = this.searchParams.devCode
                    this.deviceShow = true
                    this.fileUpload = true
                    this.fileUrlShow = true
                } else {
                    this.deviceFile = JSON.parse(JSON.stringify(row))
                    this.deviceShow = true
                    this.fileUpload = true
                    this.fileUrlShow = true
                }
            },
            saveDeviceFile(device) {
                if (this.deviceFile.fileUrl == undefined || this.deviceFile.fileUrl == '') {
                    this.$message.error('请选择文件！')
                    return
                }
                if (this.devAdd) {
                    this.$refs[device].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.addDeviceFile,
                                data: this.deviceFile
                            }
                            var self = this
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    self.$message.success('新增成功！！！')
                                    self.getDeviceFile()
                                    self.getDeviceOperationLog()
                                    self.deviceShow = false
                                } else {
                                    self.$message.error('新增失败！！！')
                                }
                            })
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$refs[device].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.editDeviceFile,
                                data: this.deviceFile
                            }
                            var self = this
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    self.$message.success('编辑成功！！！')
                                    self.getDeviceFile()
                                    self.getDeviceOperationLog()
                                    self.deviceShow = false
                                } else {
                                    self.$message.error('编辑失败！！！')
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
                this.getDeviceOperationLog()
            },
            deleteDeviceFile(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                params: {
                                    dfId: row.dfId
                                },
                                url: this.$api.deleteDeviceFile
                            })
                            .then(response => {
                                this.getDeviceFile()
                                this.getDeviceOperationLog()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getDeviceFile()
                                this.getDeviceOperationLog()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getDeviceFile()
                        this.getDeviceOperationLog()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            updatePlanMantain(row) {
                this.getAllRole()
                if (this.planAdd) {
                    this.planMantain = {}
                    this.planMantain.devCode = this.searchParams.devCode
                    this.planManShow = true
                } else {
                    this.planMantain = JSON.parse(JSON.stringify(row))
                    this.planManShow = true

                    this.thisPmiId = row.pmiId

                    this.getPlanMainByPmiId(this.thisPmiId)
                    this.getPlanMainCheckByPmiId(this.thisPmiId)
                }
            },
            getPlanMainByPmiId(pmiId){
                this.$forceUpdate()
                this.planMantain.userList = []

                let pmiIds = pmiId

                let queryParams = {
                    pmiId: pmiIds = undefined ? pmiIds:this.thisPmiId
                }

                let options = {
                    method: 'GET',
                    url: this.$api.getUserItemByPmiId,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if(pmiId !== undefined){
                        if (response.status == 100 && response.data.pmiId != null) {
                            this.userChange(response.data.roleList);
                            this.planMantain.roleList = response.data.roleList
                            this.planMantain.userList = response.data.userList
                        }
                    }else{
                        if (response.status == 100 && response.data.pmiId != null) {
                            this.userChange(this.planMantain.roleList,response.data.userList);
                        }else{
                            this.userChange();
                        }
                    }
                })
            },
            getPlanMainCheckByPmiId(pmiId){
                this.$forceUpdate()
                let pmiIds = pmiId

                let queryParams = {
                    pmiId: pmiIds = undefined ? pmiIds:this.thisPmiId
                }

                let options = {
                    method: 'GET',
                    url: this.$api.getUserItemCheckByPmiId,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if(pmiId !== undefined){
                        if (response.status == 100 && response.data.pmiId != null) {
                            this.checkUserChange(response.data.roleList);
                            this.planMantain.checkRoleList = response.data.roleList
                            this.planMantain.checkUserList = response.data.userList
                        }
                    }else{
                        if (response.status == 100 && response.data.pmiId != null) {
                            this.checkUserChange(this.planMantain.checkRoleList,response.data.userList);
                        }else{
                            this.checkUserChange();
                        }
                    }
                })
            },
            savePlanMan(planMan) {
                if (this.planAdd) {
                    this.$refs[planMan].validate((valid) => {
                        if (valid) {
                            this.planMantain.firstMaintainTime = moment(this.planMantain.firstMaintainTime).format('YYYY-MM-DD')
                            let options = {
                                method: 'POST',
                                url: this.$api.addPlanMantainItem,
                                data: this.planMantain
                            }
                            var self = this
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    self.$message.success('新增成功！！！')
                                    self.getPlanMantainItem()
                                    self.getDeviceOperationLog()
                                    self.planManShow = false
                                } else {
                                    self.$message.error('新增失败！！！')
                                }
                            })
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$refs[planMan].validate((valid) => {
                        if (valid) {
                            this.planMantain.firstMaintainTime = moment(this.planMantain.firstMaintainTime).format('YYYY-MM-DD')
                            let options = {
                                method: 'POST',
                                url: this.$api.editPlanMantainItem,
                                data: this.planMantain
                            }
                            var self = this
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    self.$message.success('编辑成功！！！')
                                    self.getPlanMantainItem()
                                    self.getDeviceOperationLog()
                                    self.planManShow = false
                                } else {
                                    self.$message.error('编辑失败！！！')
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
                this.clearUsers()
                this.getDeviceOperationLog()
            },
            getPlanMantainItem() {
                if (this.searchParams.devCode == undefined || this.searchParams.devCode == '') {
                    return
                }
                let queryParams = {
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getPlanMantainItemDevCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.planMantainList = response.data

                        if(this.planMantainList != null){
                            //保养计划循环添加推送用户/验收用户
                            this.planMantainList.forEach(item => {
                                let pushUser = ''
                                let checkUser = ''

                                if(item.pushUserList != null){
                                    item.pushUserList.forEach(push =>{
                                        if(pushUser == ''){
                                            pushUser = push.userName;
                                        }else{
                                            pushUser = pushUser + ',' + push.userName
                                        }
                                    })
                                }

                                if(item.checkUserLists != null){
                                   item.checkUserLists.forEach(check =>{
                                       if(checkUser == ''){
                                           checkUser = check.userName;
                                       }else{
                                           checkUser = checkUser + ',' + check.userName
                                       }
                                   })
                                }

                                item['pushUser']= pushUser;

                                item['checkUser']= checkUser;
                            })
                        }
                    }
                })
            },
            updateDailyCheckd(row) {
                if (this.dailyAdd) {
                    this.dailyCheckd = {}
                    this.dailyCheckd.devCode = this.searchParams.devCode
                    this.dailyCheckdShow = true
                } else {
                    this.dailyCheckd = {
                        dciId: row.dciId,
                        devCode: row.devCode,
                        ckType: row.ckType.code,
                        dciPart: row.dciPart,
                        dciDesc: row.dciDesc,
                        checkValType: row.checkValType.code,
                        remark: row.remark,
                        productCode: row.productCode,
                        dciNum: row.dciNum
                    }
                    this.dailyCheckdShow = true
                }
            },
            saveDailyCheckd(daily) {
                if (this.dailyAdd) {
                    this.$refs[daily].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.addDailyCheckItem,
                                data: this.dailyCheckd
                            }
                            var self = this
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    self.$message.success('新增成功！！！')
                                    self.getDailyCheckItem()
                                    self.getDeviceOperationLog()
                                    self.dailyCheckdShow = false
                                } else {
                                    self.$message.error(response.message)
                                }
                            })
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$refs[daily].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.editDailyCheckItem,
                                data: this.dailyCheckd
                            }
                            var self = this
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    self.$message.success('编辑成功！！！')
                                    self.getDailyCheckItem()
                                    self.getDeviceOperationLog()
                                    self.dailyCheckdShow = false
                                } else {
                                    self.$message.error('编辑失败！！！')
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
            },
            getDailyCheckItem() {
                if (this.searchParams.devCode == undefined || this.searchParams.devCode == '') {
                    return
                }
                let queryParams = {
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getDailyCheckItemDevCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.dailyCheckdList = response.data
                    }
                })
            },
            deleteDailyCheckd(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'GET',
                                params: {
                                    dciId: row.dciId
                                },
                                url: this.$api.deleteDailyCheckItem
                            })
                            .then(response => {
                                this.getDailyCheckItem()
                                this.getDeviceOperationLog()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getDailyCheckItem()
                                this.getDeviceOperationLog()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getDailyCheckItem()
                        this.getDeviceOperationLog()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            deletePlanMantain(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'GET',
                                params: {
                                    pmiId: row.pmiId
                                },
                                url: this.$api.deletePlanMantainItem
                            })
                            .then(response => {
                                this.getPlanMantainItem()
                                this.getDeviceOperationLog()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getPlanMantainItem()
                                this.getDeviceOperationLog()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getPlanMantainItem()
                        this.getDeviceOperationLog()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            saveRepairExp(repair) {
                this.$refs[repair].validate((valid) => {
                    if (valid) {
                        if (this.repairExp.updFile == undefined || this.repairExp.updFile == '') {
                            this.$message.error('请选择文件！')
                            return
                        }
                        this.repairExp.repairOccurrenceTime = moment(this.repairExp.repairOccurrenceTime).format('YYYY-MM-DD HH:mm:ss')
                        let options = {
                            method: 'POST',
                            url: this.repairAdd ? this.$api.addRepairExp : this.$api.editRepairExp,
                            data: this.repairExp
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.repairShow = false
                                this.getRepairExp()
                                this.getDeviceOperationLog()
                                this.$message.success(this.repairAdd ? '新增成功!' : '编辑成功！')
                            } else {
                                this.repairShow = false
                                this.$message.error(response.message)
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
            updateRepair(row) {
                this.fileList = []
                if (this.repairAdd) {
                    this.repairExp = {}
                    this.repairExp.devCode = this.searchParams.devCode
                    this.repairShow = true
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                } else {
                    this.repairExp = JSON.parse(JSON.stringify(row))
                    var str = ''
                    for (let i = 0; i < this.repairExp.updFile.length; i++) {
                        str += this.repairExp.updFile[i] + ','
                        this.fileList.push({ name: this.repairExp.updFile[i], url: this.repairExp.updFile[i] })
                    }
                    str = str.substring(0, str.length - 1)
                    this.repairExp.updFile = str
                    this.repairExp.devCode = this.searchParams.devCode
                    this.repairShow = true
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                }
            },
            delRepair(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                params: {
                                    dreId: row.dreId
                                },
                                url: this.$api.deleteRepairExp
                            })
                            .then(response => {
                                this.getRepairExp()
                                this.getDeviceOperationLog()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getRepairExp()
                                this.getDeviceOperationLog()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getRepairExp()
                        this.getDeviceOperationLog()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            getRepairExp() {
                let queryParams = {
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getRepairExpDevCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        // this.repairExpList = response.data
                        this.repairExpList = []
                        if (response.data != undefined && response.data != '') {
                            var aa = response.data
                            for (let i = 0; i < aa.length; i++) {
                                var array = {
                                    dreId: '',
                                    faultCode: '',
                                    repairPhenomenon: '',
                                    repairReason: '',
                                    repairResolvent: '',
                                    repairOccurrenceTime: '',
                                    updFile: []
                                }
                                array.dreId = aa[i].dreId
                                array.faultCode = aa[i].faultCode
                                array.repairPhenomenon = aa[i].repairPhenomenon
                                array.repairReason = aa[i].repairReason
                                array.repairResolvent = aa[i].repairResolvent
                                array.repairOccurrenceTime = aa[i].repairOccurrenceTime
                                if (aa[i].updFile != undefined && aa[i].updFile != '') {
                                    let arr = aa[i].updFile.split(',')
                                    for (let j = 0; j < arr.length; j++) {
                                        array.updFile.push(arr[j])
                                    }
                                }
                                this.repairExpList.push(array)
                            }
                        }
                    }
                })
            },
            saveFaultCode(fault) {
                if (this.faultCodeAdd) {
                    this.$refs[fault].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.addFaultCode,
                                data: this.faultCodeDfc
                            }
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    this.faultCodeShow = false
                                    this.$message.success('新增成功！')
                                    this.getFaultCodeDevCode()
                                    this.getDeviceOperationLog()
                                } else {
                                    this.faultCodeShow = false
                                    this.$message.error('新增失败！')
                                }
                            })
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$refs[fault].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                url: this.$api.editFaultCode,
                                data: this.faultCodeDfc
                            }
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    this.faultCodeShow = false
                                    this.$message.success('编辑成功！')
                                    this.getFaultCodeDevCode()
                                    this.getDeviceOperationLog()
                                } else {
                                    this.faultCodeShow = false
                                    this.$message.error('编辑失败！')
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
            },
            updateFaultCode(row) {
                if (this.faultCodeAdd) {
                    this.faultCodeShow = true
                    this.faultCodeDfc = {}
                    this.faultCodeDfc.devCode = this.searchParams.devCode
                } else {
                    this.faultCodeShow = true
                    this.faultCodeDfc = JSON.parse(JSON.stringify(row))
                }
            },
            delFaultCode(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                params: {
                                    dfcId: row.dfcId
                                },
                                url: this.$api.deleteFaultCode
                            })
                            .then(response => {
                                this.getFaultCodeDevCode()
                                this.getDeviceOperationLog()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getFaultCodeDevCode()
                                this.getDeviceOperationLog()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getFaultCodeDevCode()
                        this.getDeviceOperationLog()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            getFaultCodeDevCode() {
                let queryParams = {
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getFaultCodeDevCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.faultCodeList = response.data
                    }
                })
            },
            editDevice() {
                var self = this
                if (self.searchParams.devStatus == '' || self.searchParams.devStatus == null) {
                    self.$message.info('请选择状态')
                    return
                }
                if (self.searchParams.devName == '' || self.searchParams.devName == null) {
                    self.$message.info('请输入设备名')
                    return
                }
                if (self.searchParams.yearOfManu == '' || self.searchParams.yearOfManu == null) {
                    self.$message.info('请选择出厂年份')
                    return
                }
                if (self.searchParams.dateOfArri == '' || self.searchParams.dateOfArri == null) {
                    self.$message.info('请选择进厂日期')
                    return
                }
                if (self.searchParams.serviceLife == '' || self.searchParams.serviceLife == null) {
                    self.$message.info('请输入使用年限')
                    return
                }
                if (self.shopSelected == '') {
                    self.$message.info('请选择所属车间')
                    return
                }
                if (self.sectionSelected == '') {
                    self.$message.info('请选择所属工段')
                    return
                }
                if (self.lineSelected == '') {
                    self.$message.info('请选择所属产线')
                    return
                }
                let queryParams = {
                    devId: self.searchParams.devId,
                    devCode: self.searchParams.devCode,
                    devName: self.searchParams.devName,
                    shopCode: JSON.parse(self.shopSelected).deptCode,
                    shopName: JSON.parse(self.shopSelected).deptName,
                    sectionCode: JSON.parse(self.sectionSelected).deptCode,
                    sectionName: JSON.parse(self.sectionSelected).deptName,
                    lineCode: JSON.parse(self.lineSelected).deptCode,
                    lineName: JSON.parse(self.lineSelected).deptName,
                    note: self.searchParams.note,
                    keyDevices: self.searchParams.keyDevices,
                    person: self.searchParams.person,
                    personNo: self.searchParams.personNo,
                    yearOfManu: moment(self.searchParams.yearOfManu).format('YYYY-MM-DD'),
                    dateOfArri: self.dateFormat(self.searchParams.dateOfArri),
                    serviceLife: self.searchParams.serviceLife,
                    devStatus: self.searchParams.devStatus,
                    devSupplier: self.searchParams.devSupplier,
                    devSupConInf: self.searchParams.devSupConInf,
                    devSupplierAddress: self.searchParams.devSupplierAddress,
                    assetsNo: self.searchParams.assetsNo
                }
                let options = {
                    method: 'POST',
                    url: this.$api.editDevice,
                    data: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.$message.success('编辑成功！！！')
                        sessionStorage.setItem('editDeviceParam', JSON.stringify(this.searchParams))
                        this.getDeviceOperationLog()
                    } else {
                        self.$message.error('编辑失败！！！')
                    }
                })
            },
            getDeviceOperationLog() {
                if (this.searchParams.devCode == undefined || this.searchParams.devCode == '') {
                    return
                }
                let queryParams = {
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getDeviceOperationLogDevCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.deviceOperationLogList = response.data
                    }
                })
            },
            getData() {
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                let self = this
                this.$http.request(options).then(response => {
                    self.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        var factorys = self.factoryTree[i]
                        if (factorys.hasOwnProperty('deptCode')) {
                            if (factorys.deptCode == self.searchParams.fcCode) {
                                self.fcIdSelected = JSON.stringify(factorys)
                            }
                        }
                        var shop = factorys.child
                        for (var j = 0; j < shop.length; j++) {
                            if (shop[j].hasOwnProperty('deptCode')) {
                                if (shop[j].deptCode == self.searchParams.shopCode) {
                                    self.shopSelected = JSON.stringify(shop[j])
                                }
                            }
                            var vsm = shop[j].child
                            for (var v = 0; v < vsm.length; v++) {
                                if (vsm[v].hasOwnProperty('deptCode')) {
                                    if (vsm[v].deptCode == self.searchParams.sectionCode) {
                                        self.sectionSelected = JSON.stringify(vsm[v])
                                    }
                                }
                                var line = vsm[v].child
                                for (var l = 0; l < line.length; l++) {
                                    if (line[l].hasOwnProperty('deptCode')) {
                                        if (line[l].deptCode == self.searchParams.lineCode) {
                                            self.lineSelected = JSON.stringify(line[l])
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
                self.getDeviceFile()
                self.getDailyCheckItem()
                self.getPlanMantainItem()
                self.getRepairExp()
                self.getFaultCodeDevCode()
                self.getDeviceOperationLog()
                self.detectnItemList()
                self.getDeviceRunStatusChange()
            },
            getFileTypeList() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.enumTypelist,
                    params: {
                        enumType: 'dev_file'
                    }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.fileTypeList = response.data
                    }
                })
            },
            deviceChangePaginationChange(val) {
                this.deviceChangeData.pageSize = val
                this.searchTable()
            },
            deviceChangePaginationCurrentChange(val) {
                this.deviceChangeData.page = val
                this.searchTable()
            },
            async exportDeviceRunStatusChange() {
                let options = {
                    url: this.$api.exportDeviceRunStatusChange,
                    method: 'POST',
                    params: {
                        devCode: this.searchParams.devCode
                    },
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '设备运行状态信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            //设备状态变化分页查询
            getDeviceRunStatusChange() {
                let queryParams = {
                    pageSize: this.deviceChangeData.pageSize,
                    pageNum: this.deviceChangeData.page,
                    devCode: this.searchParams.devCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getDeviceRunStatusChange,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.deviceChangeList = response.data.list
                        this.deviceChangeData.pageCount = response.data.total
                    }
                })
            },
            /*处理表格日期格式*/
            dateFormatTime: function(row, column) {
                var date = row[column.property]
                if (date == undefined) {
                    return ''
                }

                return moment(date).format('YYYY-MM-DD HH:mm:ss')
            },
            /*处理新增编辑日期格式*/
            dateFormat(date) {
                return moment(date).format('YYYY-MM-DD HH:mm:ss')
            },
            getAllRole() {
              var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
              var data = {
                pageSize: 100,
                pageNum: 1,
                fcCode: this.searchParams.fcCode
              }
              let options = {
                method: 'GET',
                params: data,
                url: this.$api.getAllRole
              }
              this.$http.request(options).then(response => {
                if (response.status === 100) {
                  this.roleList = response.data.list
                }
              })
            },
            userChange(roleList,userList){
                this.planMantain.userList = []

                let options = {
                  method: 'POST',
                  data: roleList != null ? roleList:this.planMantain.roleList,
                  url: this.$api.getUserByRole
                }
                this.$http.request(options).then(response => {
                  if (response.status === 100) {

                    if(userList != null){
                        let userLists = []

                        userList.forEach(result => {
                            response.data.forEach(user => {
                                if(result == user.userId){
                                    userLists.push(result)
                                }
                            })
                        })

                        this.planMantain.userList = userLists
                    }

                    this.userList = response.data
                    this.selectUserList = response.data
                  }
                })
            },
            checkUserChange(roleList,userList){
                this.planMantain.checkUserList = []

                let options = {
                  method: 'POST',
                  data: roleList != null ? roleList:this.planMantain.checkRoleList,
                  url: this.$api.getUserByRole
                }
                this.$http.request(options).then(response => {
                  if (response.status === 100) {

                    if(userList != null){
                        let userLists = []

                        userList.forEach(result => {
                            response.data.forEach(user => {
                                if(result == user.userId){
                                    userLists.push(result)
                                }
                            })
                        })

                        this.planMantain.checkUserList = userLists
                    }

                    this.checkUserList = response.data
                  }
                })
            },
            clearUsers(){
                this.userList = []
                this.checkUserList = []
                // this.planMantainList.userList = []
                this.$forceUpdate()
            },
            clearSelect(){
                this.selectPmiList = [],
                this.selectRoleList = [],
                this.selectUserList = [],
                this.planSelectList.roleList = [],
                this.planSelectList.userList = [],
                this.$refs.multipleTable.clearSelection();
                this.$forceUpdate()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            updateConfig(){
                if(this.multipleSelection.length == 0){
                    var self = this
                    self.$message.warning('请选择保养项目!')
                }else{
                    this.multipleSelection.forEach(e =>{
                        this.selectPmiList.push(e.pmiId)
                    })

                    this.planPushORCheckShow = true
                }
            },
            getConfigRoleList(){
                this.userChange(this.planSelectList.roleList,null)
            },
            addItem(){
                if(this.planSelect){
                    this.insertItemByPmiId()
                }else{
                    this.insertItemCheekByPmiId()
                }
            },
            insertItemCheekByPmiId(){
                let postParams = {
                    pmiList: this.selectPmiList,
                    roleList: this.planSelectList.roleList,
                    userList: this.planSelectList.userList,
                }

                let options = {
                  method: 'POST',
                  data: postParams,
                  url: this.$api.addItemCheekByPmiId
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.$message.success('新增成功！！！')

                    } else {
                        this.$message.error('新增失败！！！')
                    }

                    this.$refs.multipleTable.clearSelection();
                    this.$forceUpdate()
                    this.planPushORCheckShow = false
                })
            },
            insertItemByPmiId(){
                let postParams = {
                    pmiList: this.selectPmiList,
                    roleList: this.planSelectList.roleList,
                    userList: this.planSelectList.userList,
                }

                let options = {
                  method: 'POST',
                  data: postParams,
                  url: this.$api.addItemByPmiId
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.$message.success('新增成功！！！')

                    } else {
                        this.$message.error('新增失败！！！')
                    }

                    this.planPushORCheckShow = false
                })
            },
        }
    }
</script>

<style scoped>
</style>
